<template>
    <div class="plainCard plainCard-small">
        <p
            class="has-text-centered has-text-secondary-black has-text-weight-bold"
        >
            Filtros
        </p>
        <p class="has-text-centered has-text-grey-dark is-size-7 mb-4">
            {{ filterType }}
        </p>
        <slot :fields="fields"></slot>
        <b-select
            title="dateSelector"
            expanded
            placeholder="Selecciona un periodo"
            v-model="selectedPeriod"
        >
            <option
                v-for="option in periodOptions"
                :value="option.id"
                :key="option.id"
            >
                {{ option.name }}
            </option>
        </b-select>
        <b-slider
            class="my-5"
            v-model="selectedRange"
            :min="0"
            :max="maxSliderVal"
            :step="1"
            :indicator="true"
            :custom-formatter="(val) => monthsRange[val]"
            tooltip-always
            :tooltip="false"
            :disabled="rangeDisabled"
        >
        </b-slider>
        <b-button
            class="mb-3"
            expanded
            type="is-primary"
            @click="onFilter"
            data-test="searchButton"
            >Buscar
        </b-button>
        <b-button
            expanded
            class="cleanSearchButton"
            type="is-primary"
            outlined
            @click="onClean"
        >
            Limpiar búsqueda
        </b-button>
    </div>
</template>

<script>
import moment from "moment";
import { filterPeriodOptions, monthsNames } from "./componentData";

export default {
    name: "ChartFilter",
    data() {
        return {
            periodOptions: filterPeriodOptions,
            selectedPeriod: filterPeriodOptions[0].id,
            selectedRange: [0, 11],
            monthsRange: monthsNames,
            rangeDisabled: true,
            fields: {},
        };
    },
    props: {
        fieldsName: {
            type: Array,
            default: () => [],
        },
        filterType: {
            type: String,
            default: "",
        },
    },
    methods: {
        fieldsNameToObject() {
            return this.fieldsName.reduce(
                (obj, item) => ({ ...obj, [item.name]: item.default }),
                {}
            );
        },
        onFilter() {
            const selected = this.periodOptions.find(
                (item) => item.id === this.selectedPeriod
            );
            let emittedData = {
                start_date: selected.start_date,
                end_date: selected.end_date,
                ...this.fields,
            };
            if (!this.rangeDisabled) {
                emittedData.start_date = moment(selected.start_date)
                    .add(this.selectedRange[0], "month")
                    .format("YYYY-MM-DD");
                emittedData.end_date = moment(selected.end_date)
                    .subtract(
                        this.maxSliderVal - this.selectedRange[1],
                        "month"
                    )
                    .format("YYYY-MM-DD");
            }
            this.$emit("on-filter", emittedData);
        },
        onClean() {
            this.selectedPeriod = "last12Months";
            this.fields = this.fieldsNameToObject();
            this.$emit("on-clean-filter");
        },
    },
    computed: {
        maxSliderVal: function() {
            if (this.selectedPeriod === "currentYear") {
                return moment().month();
            }
            return 11;
        },
    },
    mounted() {
        this.fields = this.fieldsNameToObject();
    },
    watch: {
        selectedPeriod(item) {
            if (item === "last12Months" || item === "currentMonth") {
                this.rangeDisabled = true;
            } else {
                this.rangeDisabled = false;
            }
            if (this.selectedPeriod !== "currentYear") {
                this.selectedRange = [0, 11];
            }
        },
    },
};
</script>
